import { useEffect, useState } from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Card, CardBody, CardHeader } from '_metronic/_partials/controls';
import TextField from 'app/components/common/TextField';
import { ActionBarAdd, ActionBarEdit } from 'app/components/common/ActionBar';
import Clinic from 'app/models/Clinic';
import OperationTable from 'app/models/OperationTable';
import swal from 'sweetalert2';
import { useParams, useHistory } from 'react-router-dom';
import { ArrowBackIosOutlined } from '@material-ui/icons';

const OperationTableEditPage = ({ data, isEditing = true, headerToolbar, mode }) => {
  let [clinicList, setClinicList] = useState([]);
  let [operationTableData, setOperationTableData] = useState(null);

  const history = useHistory();
  const { id } = useParams();

  const fetchClinicList = async () => {
    let clinicModel = new Clinic();
    try {
      let result = await clinicModel.getAllClinic();

      setClinicList(result);
      console.log(result);
    } catch (e) {
      console.log('ERROR' + e);
    }
  };

  const editOperationTable = formValues => {
    console.log(formValues);

    let operationTableModel = new OperationTable();

    try {
      let result = operationTableModel.editOperationTable(id, {
        clinic_id: formValues.clinicType,
        type: formValues.operationType,
        name: formValues.operationName
      });
      swal.fire({
        title: 'Success',
        text: 'Operation Table edited successfully',
        icon: 'success',
        confirmButtonText: 'Go back',
        customClass: {
          container: 'swal-z'
        }
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  const getOperationTableDetail = async id => {
    let operationTableModel = new OperationTable();

    try {
      let result = await operationTableModel.getOperationTableById(id);
      setOperationTableData(result);
    } catch (e) {
      console.log('error: ', e);
    }
  };

  const operationOptions = ['SMALL', 'BIG'];

  const { values, handleChange, handleSubmit, handleReset, setFieldValue } = useFormik({
    initialValues: {
      operationName: operationTableData?.name || '',
      clinicType: operationTableData?.clinic_id ?? null,
      operationType: operationTableData?.type || null
    },
    validationSchema: Yup.object({
      operationName: Yup.string().required('Cannot be empty')
    }),
    onSubmit: formValues => {
      editOperationTable(formValues);
    },
    enableReinitialize: true
  });

  useEffect(() => {
    fetchClinicList();
    getOperationTableDetail(id);
  }, []);

  return (
    <Card>
      <div className="card-header">
        <div className="mt-4 card-title">
          <span
            style={{
              cursor: 'pointer'
            }}
          >
            <ArrowBackIosOutlined onClick={() => history.goBack()}></ArrowBackIosOutlined>
          </span>
          <h3 className="ml-3 mt-3 mb-2">{`Edit ${operationTableData?.name}`}</h3>
        </div>
      </div>
      <CardBody>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="clinicType"
                select
                value={values.clinicType}
                onChange={event => {
                  setFieldValue('clinicType', event.target.value);
                }}
                label="Clinic Name *"
                InputLabelProps={{ shrink: !!values.clinicType }}
              >
                {clinicList.map((obj, key) => (
                  <MenuItem key={obj.id} value={obj.id}>
                    {`${obj.name}`}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField value={values.operationName} onChange={handleChange} name="operationName" label="Name" />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="operationType"
                select
                value={values.operationType}
                onChange={event => {
                  setFieldValue('operationType', event.target.value);
                }}
                label="Type *"
                InputLabelProps={{ shrink: !!values.operationType }}
              >
                {operationOptions.map(obj => (
                  <MenuItem key={obj} value={obj}>
                    {`${obj}`}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <ActionBarEdit isEditing={true} handleSubmit={handleSubmit} handleDelete={handleReset} />
          </Grid>
        </form>
      </CardBody>
    </Card>
  );
};

export default OperationTableEditPage;
